import './card-average.scss';

export default () => {

};
